import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

type MediaCardSkeletonProps = {
  className?: string;
};

const MediaCardSkeleton = ({ className }: MediaCardSkeletonProps) => {
  return (
    <article
      className={cn("h-[300px] rounded-2xl bg-white p-1 border", className)}
    >
      <div className="flex h-full flex-col overflow-hidden rounded-xl">
        <Skeleton className="h-[170px] w-full rounded-xl sm:h-[190px]" />

        <div className="flex flex-1 flex-col justify-between px-1 py-4">
          <div className="space-y-3">
            <Skeleton className="h-6 w-[60%] rounded-full" />
            <Skeleton className="h-4 w-[38%] rounded-full" />
          </div>

          <div className="flex items-end justify-between gap-2 ">
            <Skeleton className="h-4 w-[32%] rounded-full" />
            <Skeleton className="h-9 w-[26%] rounded-full" />
          </div>
        </div>
      </div>
    </article>
  );
};

export default MediaCardSkeleton;
